export default __webpack_public_path__ + "static/media/caret.87109db4.svg";